// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Cart as CoveoCart } from "@coveo/headless/commerce";
import { ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    cart?: CartModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

// Keep track of processed cart IDs to prevent duplicate events
const processedCartIds = new Set<string>();

const CoveoPurchaseChainTap = (coveoCart: CoveoCart): HandlerType => props => {
    const cartId = props.apiResult.cart.id;
    
    console.log("PURCHASE EVENT >> Cart Items:", coveoCart.state.items);

    // Only process if we haven't seen this cart ID before
    if (!processedCartIds.has(cartId)) {
        console.log("PURCHASE EVENT >> Cart ID:", cartId);
        
        // Validate that Coveo cart matches cartline
        if (props.apiResult.cart.cartLines && coveoCart.state.items) {
            const actualCartProductIds = new Set(
                props.apiResult.cart.cartLines.map(line => line.productId)
            );
            
            // Check if there's a mismatch between coveoCart and actual cart
            const hasInvalidItems = coveoCart.state.items.some((item: { productId: string | null; }) => 
                !actualCartProductIds.has(item.productId)
            );
            
            // If there's a mismatch, synchronize the carts before sending the purchase event
            if (hasInvalidItems) {
                console.log("PURCHASE EVENT >> Mismatch detected, synchronizing cart before purchase event");
                
                // Filter out invalid items directly from the state
                // @ts-ignore - Direct state modification is necessary here to avoid analytics events
                coveoCart.state.items = coveoCart.state.items.filter(item => 
                    actualCartProductIds.has(item.productId)
                );
                
                console.log("PURCHASE EVENT >> Synchronized cart items:", coveoCart.state.items);
            }
        }
        
        // Send purchase event with validated cart data
        coveoCart.purchase({
            id: cartId,
            revenue: props.apiResult.cart.orderGrandTotal || 0,
        });
        
        // Mark this cart as processed
        processedCartIds.add(cartId);
        
        // Clean up the processed cart ID after a delay to prevent memory leaks
        setTimeout(() => {
            processedCartIds.delete(cartId);
        }, 5000); // 5 second delay
    }
};

export default CoveoPurchaseChainTap;